import { get } from '../axios'

/**
 * 获取所有记者
 * @param {*} id 频道id
 * @param {*} type 类型
 * @returns
 */
const getAuthors = (id, type = 'REPORT') => {
  return get('/activity/timeline/category/child/related/posters', { id, type })
}
export default {
  getAuthors
}
